module.exports = __webpack_public_path__ + "img/xpm.0a6ba582.svg";